let currentShippingId;

const editShipping = (name) => {
    currentShippingId = name
    openEditShippingForm()
}

const setShipping = () => {
    const shippingRef = database.ref('/shippings/' + currentShippingId)
    const shipping = {
        country: shippings[currentShippingId].country,
        name: $('#shipping-name').val(),
        price: $('#shipping-price').val()
    }
    shippingRef.set(shipping).then(() => {
        closeModal();
    })
}

const removeShipping = () => {
    const shippingRef = database.ref('/shippings/' + currentShippingId);
    shippingRef.remove();
}

const openEditShippingForm = () => {
    const shipping = shippings.find(item => item.id === currentShippingId);
    
    $('.pent-modal').addClass('open');
    let modalContent = `
        <div class="modal-content admin-form">
            <img
                class="modal-close-button"
                src="/assets/images/ui/close-button.png"
                onClick="closeModal()"
                >
            <h4 class="modal-title mt-2">Edita Spedizione</h4>
            <div class="spacer" style="height: 50px"></div>
            <div class="modal-content-in pl-2 pr-2">
                <div class="form-group">
                    <label for="pent-size pb-2">Nome Corriere</label>
                    <input type="text" value="${shipping.name}" id="shipping-name" class="form-control">
                    </input>
                </div>
                <div class="form-group">
                    <label for="pent-size pb-2">Prezzo</label>
                    <input type="number" value="${shipping.price}" id="shipping-price" class="form-control">
                    </input>
                </div>
            </div>
            <div onClick="setShipping()" class="pl-2 pr-2 pb-2">
                <button class="w-100 small formal bg-green text-white"><small>Salva</small></button>
            </div>
        </div>
    `
    $('.pent-modal').append(modalContent);
}
